export default __webpack_public_path__ + "static/media/DNo.21-2.68a92788.jpg";